import { useFetch, useForm, useGrid, useModal, usePage, useStore } from "@/comn/hooks";
import { PGEUIDS, SF_MENU_SCRN_SRCH, SG_SCRN_LIST } from "@/tra/tancis/ptli/ptl/menuscrn/services/PtliMenuScrnService";
import * as scrnService from "@/tra/tancis/ptli/ptl/scrn/services/PtliScrnService";
import { comnUtils } from "@/comn/utils";
import { useEffect } from "react";
import { Grid, Group, Layout, Page } from "@/comn/components";

/*
 * Screen List Popup
 * !== 화면 목록 팝업 ==!
 */
export const PTLI1003003Q = (props: any) => {
    const { bsopClsfCd, ptlTpCd, menuId, callback, menuScrnList } = props;

    const { pgeUid } = usePage({ pgeUid: PGEUIDS.ptli1003003q });
    const modal = useModal();
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid });
    const grid = {
        scrnList: useGrid({
            defaultSchema: {
                ...SG_SCRN_LIST,
                options: { ...SG_SCRN_LIST.options, checkbox: true, index: true },
                head: [
                    { cells: [{ header: "L_SCRN_ID", binding: "scrnId", width: "*" }] },
                    { cells: [{ header: "L_SCRN_NM", binding: "scrnNm", width: "*" }] },
                    { cells: [{ header: "L_SCRN_URL_ADDR", binding: "scrnUrlAddr", width: "*" }] },
                    { cells: [{ header: "L_SCRN_DESC", binding: "scrnDesc", width: "*" }] },
                    { show: false, cells: [{ binding: "chkYn" }] },
                    { show: false, cells: [{ binding: "menuCnctYn" }] },
                    { show: false, cells: [{ binding: "menuId" }] },
                ],
            },
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };
    const form = { scrnMgmtSrch: useForm({ defaultSchema: SF_MENU_SCRN_SRCH }) };

    const fetch = {
        getScrnList: useFetch({
            api: (page = grid.scrnList.page, size = grid.scrnList.size) =>
                scrnService.APIS.getScrnList(form.scrnMgmtSrch.getValues(), page, size),
            enabled:
                !comnUtils.isEmpty(form.scrnMgmtSrch.getValue("bsopClsfCd")) &&
                !comnUtils.isEmpty(form.scrnMgmtSrch.getValue("ptlTpCd")),
            key: [grid.scrnList.page, grid.scrnList.size],
            onSuccess: (data: any) => {
                const scrnList = data.scrnList;
                scrnList.content.forEach((item: any, index: number) => {
                    if (menuScrnList.findIndex((subItem: any) => item.scrnId === subItem.scrnId) > -1) {
                        item = { ...item, menuId: menuId };
                        scrnList.content = scrnList.content.with(index, item);
                    }
                });

                grid.scrnList.setData(scrnList);

                setStore(pgeUid, {
                    form: form.scrnMgmtSrch.getValues(),
                    page: grid.scrnList.page,
                    size: grid.scrnList.size,
                });
            },
            onError: () => modal.openModal({ content: "msg.com.00025" }), // 조회가 실패하였습니다.
        }),
    };

    const render = {
        scrnList: { checkbox: (rowValues: any) => rowValues.menuId != menuId },
    };

    const handler = {
        onApplyBtnClick: () => {
            if (!grid.scrnList.isChecked()) {
                modal.openModal({ content: "msg.ptl.00687" }); // 등록대상을 선택하세요.
                return;
            }

            callback(grid.scrnList.getChecked());
        },
        onSearchBtnCiick: () => {
            form.scrnMgmtSrch.handleSubmit(
                () => fetch.getScrnList.fetch(),
                () => modal.openModal({ content: "msg.ptl.00684" }), // 조회 조건 필수 입력 항목을 입력하시기 바랍니다.
            )();
        },
    };

    useEffect(() => {
        form.scrnMgmtSrch.setEditable("ptlTpCd", false);
        form.scrnMgmtSrch.setValue("bsopClsfCd", bsopClsfCd);
        form.scrnMgmtSrch.setValue("ptlTpCd", ptlTpCd);
    }, []);

    return (
        <Page pgeUid={pgeUid} info={true}>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.scrnMgmtSrch.schema.bsopClsfCd} />
                            <Group.Control {...form.scrnMgmtSrch.schema.ptlTpCd} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.scrnMgmtSrch.schema.scrnId} />
                            <Group.Control {...form.scrnMgmtSrch.schema.scrnNm} />
                        </Group.Row>
                    </Group.Section>
                    <Layout>
                        <Layout.Right>
                            {" "}
                            <Layout.Button role={"search"} onClick={handler.onSearchBtnCiick} />
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>
            <Group>
                <Group.Body>
                    <Grid {...grid.scrnList.grid} data={fetch.getScrnList.data?.scrnList} render={render.scrnList} />
                    <Layout>
                        <Layout.Right>
                            <Layout.Button role={"apply"} onClick={handler.onApplyBtnClick}></Layout.Button>
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>
        </Page>
    );
};
